module.exports = __webpack_public_path__ + "static/img/055_TO8_1598_og.58b566d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/055_TO8_1598_og.jpg
// module id = wsdF
// module chunks = 0